import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { withTheme } from 'emotion-theming';
import { SquareBorderButton, Upload } from '@lyearn-team/frontend-components';
import showFileResponse from 'helper/uppy/fileUploader';

const UploadButtonWrapper = withTheme(styled.div`
  ${({ theme: { color } }) => `
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px dashed ${color.grey2};
    border-radius: 4px;
    height: 90px;
  `}
`);

class AttachmentSettings extends Component {
  static contextTypes = {
    showLoading: PropTypes.func,
    hideLoading: PropTypes.func,
    dispatch: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      fileName: '',
      url: ''
    };
  }

  onDeleteFIle = () => {
    this.fileUploaded(null, true);
  };

  fileUploaded = (r, deleteFile) => {
    if (deleteFile === true) {
      this.context.dispatch('UPDATE_ITEM_MEDIA', {
        _id: this.props.blockItem.items[0]._id,
        media: {
          attachment: {
            src: '',
            fileSize: 0,
            fileName: ''
          }
        }
      });
      return;
    }
    const url = r.url;
    const filename = r.filename;
    const fileSize = r.size;
    this.context.dispatch('UPDATE_ITEM_MEDIA', {
      _id: this.props.blockItem.items[0]._id,
      media: {
        attachment: {
          src: url,
          fileSize,
          fileName: filename
        }
      }
    });
  };

  uploadFile = () => {
    window.fs_filepicker = window.filestack && window.filestack.init('AuG7ZQSxaSemtziJGYwbsz');
    this.context.showLoading();
    window.fs_filepicker
      .picker({
        fromSources: [
          'local_file_system',
          'url',
          'imagesearch',
          'facebook',
          'instagram',
          'googledrive',
          'dropbox',
          'github',
          'gmail',
          'webcam',
          'video',
          'audio'
        ],
        maxFiles: 1,
        minFiles: 1,
        onOpen: () => {
          this.context.hideLoading();
        },
        onFileUploadFinished: data => {
          try {
            this.fileUploaded(data);
          } catch (e) {
            console.error(e);
          }
        }
      })
      .open();
  };

  render() {
    const { items } = this.props.blockItem;
    const { src: fileUrl, fileName } = items[0].media.attachment;

    if (fileUrl) {
      // const { fileName, fileUrl } = JSON.parse(response);
      return (
        <Upload
          downloadUrl={fileUrl}
          showPreview={true}
          fileName={fileName || fileUrl}
          showDelete={true}
          onDeleteUpload={this.onDeleteFIle}
        />
      );
    }
    return (
      <UploadButtonWrapper>
        <SquareBorderButton
          text="Upload File"
          icon={{
            type: 'upload',
            style: { height: '15px', width: '18px', marginRight: '6px' }
          }}
          size="medium"
          onClick={() =>
            showFileResponse(this.props.blockItem.items[0]._id, this.fileUploaded, 'upload')
          }
          type="filled"
        />
      </UploadButtonWrapper>
    );
  }
}

export default AttachmentSettings;
